@let auth = authenticatedUser$ | async;
@let p = auth?.authenticatedUser | bgoUserPerspective;
<ng-container *transloco="let t">
  <div class="navbar-shortcut-container">
    <bgo-login-shortcuts class="navbar-shortcut"></bgo-login-shortcuts>

    @if (p.admin) {
      <bgo-shortcut [icon]="adminJobsIcon" [link]="adminJobsLink" title="All Jobs"></bgo-shortcut>
    }

    @if (p.pro) {
      <bgo-shortcut [icon]="proDashboardIcon" [link]="proDashboardLink" [title]="t('navbar.pro.homeV2')"></bgo-shortcut>
    }

    @if (p.agent) {
      <bgo-shortcut
        [icon]="agentDashboardIcon"
        [link]="agentDashboardLink"
        [title]="t('navbar.agent.home')"
      ></bgo-shortcut>
    }

    @if (p.client) {
      <bgo-shortcut [icon]="clientJobsIcon" [link]="clientJobsLink" [title]="t('navbar.client.jobs')"></bgo-shortcut>
    }

    @if (auth?.authenticatedUser?.userId) {
      <bgo-shortcut [icon]="messagesIcon" [link]="messagesLink" [title]="t('navbar.user.messagesV2')">
        @if (messageUnreadCount$ | async; as unreadCount) {
          <cft-notification-bullet [amount]="unreadCount" />
        }
      </bgo-shortcut>
    }
  </div>
</ng-container>
